<template>
    <div id="DpSetDateTime">
        <div id="routeMap" style="height:300px;" ></div>
        <table class="ma-3">
            <tbody>

            <tr><td>輸送距離</td>
                <td colspan="2">{{deliveryDistance}}km(予測所要時間 {{deliveryDuration}}分)</td></tr>
            <tr>
                <td width="100">商品代金</td>
                <td class="text-xs-right">{{cartCurrent.total.toLocaleString()}}円</td>
                <td width="100"></td>
            </tr>
            <tr>
                <td>送料</td>
                <td class="text-xs-right">{{calculateFee().toLocaleString()}}円</td>
                <td width="100"></td>
            </tr>
            <tr>
                <td>合計金額</td>
                <td class="text-xs-right">{{getTotal().toLocaleString()}}円</td>
                <td width="100"></td>
            </tr>
            </tbody>
        </table>
        <h3 class="ma-3">お届け日の指定</h3>

        <!--
        <v-layout row wrap>
            <v-flex xs6 text-xs-center  px-2 v-for="(item,index) in pickupDays" :key="'pkupday_'+index">
                <v-btn
                        block
                        color="default"
                >
                    {{item.text}}
                </v-btn>
                <span>本日はお届け可能です</span>
            </v-flex>
        </v-layout>
        -->

        <v-select
                :items="pickupDays"
                outline
                v-model="pickUpDay"
                hide-details
                label="お届け日"
                class="ma-2"
                color="black"
                v-if="pickupDays.length"
        >
        </v-select>

        <div v-if="!pickupDays.length">
            <h3>ごめんなさい。お届けできる日がありません。</h3>
        </div>

        <div v-if="etas[pickUpDay] && etas[pickUpDay].length" class="ma-3">
            <h3>お届け時間を選択してください。</h3>
        </div>
        <v-layout row wrap ma-2>
        <template v-for="(time,timeIndex) in etas[pickUpDay]">
            <v-flex xs3 text-xs-center :key="'timeIndex_'+timeIndex">
                <v-btn
                        block
                        :color="setColor(time)"
                        @click="setDeliveryTime(time)"
                >{{time.eta}}</v-btn>
            </v-flex>
        </template>
        </v-layout>
        <div v-if="!etas[pickUpDay] || !etas[pickUpDay].length" class="ma-3">
            {{dayStrings[pickUpDay]}} はお届けできません。
        </div>

    </div>
</template>
<script>
import moment from 'moment-timezone'
import { AmplifyEventBus } from 'aws-amplify-vue'
import  { Logger } from 'aws-amplify';
const logger = new Logger('DpDateTime','INFO');
export default {
    //
    // This page is navigated by beforeEnter at router.js
    //
    data() {
        return {
            deliveryDuration:undefined,
            deliveryDistance:undefined,
            etas:[],
            pickUpDay:0,
        }
    },
    async mounted() {
        AmplifyEventBus.$emit('setBackTo', "/dpSetGps")
        logger.info("DpDateTime")
        logger.info("cartCurrent",this.cartCurrent)
        logger.info("gps",this.userSelect.gps)
        if(!this.cartCurrent
            || !this.cartCurrent.total
            || !this.userSelect.gps
            || !this.userSelect.gps.lat){
            alert("お届け先を設定してください")
            this.$router.push("/dpSetDestination")
            return false
        }
        this.showMap()
        this.routeMap()
        if(this.userSelect.deliveryDay && this.userSelect.deliveryDay.dayIndex >= 0){
            const dayIndex = this.userSelect.deliveryDay.dayIndex
            this.pickUpDay = dayIndex
            this.setDeliveryDay(dayIndex)
        }else{
            this.setDeliveryDay(this.pickUpDay)
        }

    },
    methods: {
        setDeliveryDay(dayIndex){
            //set day
            const day = this.businessHours["adt"].days[dayIndex]
            const deliveryDay = {}
            deliveryDay.dayIndex = this.pickUpDay
            deliveryDay.dayText = day.dayText
            deliveryDay.dayTextLang = day.dayTextLang
            deliveryDay.calendarText = day.calendarText
            logger.info("deliveryDay",deliveryDay)
            this.$set(this.userSelect,"deliveryDay",deliveryDay)
            // for compatibility
            const dayObj = {}
            dayObj.dayText = day.dayText
            dayObj.dayTextLang = day.dayTextLang
            dayObj.selectedNum = this.pickUpDay
            this.$set(this.userSelect,"day",dayObj)
            /*
            dataToEmit.dayTextLang = this.businessHours[this.serviceType].days[this.keyNum].dayTextLang
                dataToEmit.dayText = this.businessHours[this.serviceType].days[this.keyNum].dayText
                dataToEmit.keyNum = this.keyNum
             */
        },
        setDeliveryTime:function(time){
            //set time
            this.$set(this.userSelect,"deliveryTime",time)
            // compatibility
            this.$set(this.userSelect,"time",time.eta)
            this.$router.push("/dpCheckout")
        },
        setColor:function(time){
            if(this.userSelect.deliveryTime && this.userSelect.deliveryTime == time){
                return "orange"
            }else{
                return "white"
            }

        },
        getTotal:function(){
            const total = this.cartCurrent.total + this.calculateFee()
            return total
        },
        calculateFee:function(){
            logger.info("this.deliveryProvider.feeType",this.deliveryProvider.feeType)
            let fee
            if(this.deliveryProvider.feeType == "byDistance"){
                logger.info("calc fees byDistance")
                if(this.deliveryDistance*1000 <= this.deliveryProvider.fees.baseMaxDistance){
                    fee = this.deliveryProvider.fees.basePrice
                }else{
                    const base = this.deliveryProvider.fees.basePrice
                    const qty = Math.ceil( (this.deliveryDistance*1000 - this.deliveryProvider.fees.baseMaxDistance) / this.deliveryProvider.fees.byDistanceUnit)
                    fee = base + qty * this.deliveryProvider.fees.byDistancePrice
                }
            }
            this.$set(this.userSelect,"deliveryFee",fee)
            return fee
        },
        showMap: function () {
            // Google Maps loaded at index.html
            const lat = this.userSelect.gps.lat
            const lng = this.userSelect.gps.lng

            // eslint-disable-next-line
            this.map = new google.maps.Map(document.getElementById('routeMap'), {
                center: {lat: lat, lng: lng},
                zoom: 12,

            });


        },
        routeMap: function () {
            // eslint-disable-next-line
            const directionsService = new google.maps.DirectionsService;
            // eslint-disable-next-line
            const directionsRenderer = new google.maps.DirectionsRenderer({map: this.map});
            this.calculateAndDisplayRoute(
                directionsRenderer, directionsService)
        },
        calculateAndDisplayRoute(directionsRenderer, directionsService) {
            const that = this
            // eslint-disable-next-line
            const origin = new google.maps.LatLng(this.$store.state.location.lat, this.$store.state.location.lng)
            // eslint-disable-next-line
            const dest = new google.maps.LatLng(this.userSelect.gps.lat, this.userSelect.gps.lng)
            directionsService.route({
                origin: origin,
                destination: dest,
                travelMode: this.deliveryProvider.travelMode,
                avoidTolls:true,
                drivingOptions: {
                    departureTime: new Date(Date.now() + 20*60*1000),  // 20min later
                    trafficModel: 'bestguess'
                }
            }, function (response, status) {
                logger.info("status", status)
                logger.info("response", response)
                if (status === 'OK') {
                    directionsRenderer.setDirections(response);
                    that.getRouteDistance(response)
                }
            })
        },
        getRouteDistance: function (response) {
            let totalKm = 0
            let totalMin = 0
            let myRoute = response.routes[0]
            for (let i in myRoute.legs) {
                totalKm += myRoute.legs[i].distance.value
                totalMin += myRoute.legs[i].duration.value
            }
            totalKm = totalKm / 1000;
            totalMin = Math.ceil(totalMin / 60)
            logger.info("totalRouteDistance",totalKm)
            logger.info("totalRouteDuration",totalMin)
            this.deliveryDistance = totalKm
            this.deliveryDuration = totalMin
            //fees
            const deliveryRoute = {}
            deliveryRoute.response = response
            deliveryRoute.deliveryDistance = this.deliveryDistance
            deliveryRoute.deliveryDuration = this.deliveryDuration
            //logger.info("deliveryRoute",deliveryRoute)
            this.$set(this.userSelect,"deliveryRoute",deliveryRoute)
            //logger.info("userSelect",this.userSelect)

        },
        setDeliveryArrivalTimes:function(delivDur){
            logger.info("setDeliveryArrivalTimes",delivDur)
            logger.info("bizHours",this.businessHours)

            const availableTimes = {}
            for(let dayIndex=0; dayIndex<4; dayIndex++){
                availableTimes[dayIndex] = []
                const day = this.businessHours["adt"]["days"][dayIndex]
                const hours = day.times
                if(hours){
                    const disabledDurationFromNow = this.disabledDurationFromNow("adt")
                    //logger.info("disabledDurationFromNow",disabledDurationFromNow)
                    const startHour = parseInt(hours.startHour)
                    let endHour = parseInt(hours.endHour)
                    if(startHour > endHour){
                        endHour += 24
                    }
                    for(let i = startHour; i <= endHour; i++){
                        let times = hours[i]
                        let addOneDay = false
                        if(i >= 24){
                            times = hours[i-24]
                            addOneDay = true
                        }
                        //logger.info("times",times)
                        for(let j in times){
                            const time = times[j]
                            //logger.info("time",time)
                            let timeMoment = moment(time,"kk:mm").subtract(disabledDurationFromNow, 'minute')
                            if(addOneDay){
                                timeMoment.add(1,'day')
                            }
                            if(dayIndex == 0){
                                if(timeMoment.isAfter(moment())){
                                    //logger.info("found time",time)
                                    availableTimes[dayIndex].push(time)
                                }
                            }else{
                                availableTimes[dayIndex].push(time)
                            }
                        }
                    }
                }

            }

            logger.info("availableTimes",availableTimes)
            // create etas
            const etas = {}
            for(let dayIndex in availableTimes){
                const times = availableTimes[dayIndex]
                etas[dayIndex]=[]
                for(let i in times){
                    const time = times[i]
                    //const etd = time
                    const eta = moment(time,"kk:mm").add(10,"minute").add(this.deliveryDuration,"minutes")
                    const etaEtd = {}
                    etaEtd.etd = time
                    etaEtd.eta = eta.format("kk:mm")
                    etas[dayIndex].push(etaEtd)
                }
            }



            this.etas = etas
            logger.info("etas",this.etas)

        },
        disabledDurationFromNow:function(service){
            let res = 10
            //const service = this.userSelect.service.name
            if(service && this.$store.state.menu.defalutSettings
                && this.$store.state.menu.defalutSettings.disabledDurationFromNow
                && this.$store.state.menu.defalutSettings.disabledDurationFromNow[service]
            ){
                res = this.$store.state.menu.defalutSettings.disabledDurationFromNow[service]
            }
            return res

        },
    },
    computed: {
        cartCurrent(){
            let res = false
            if(!this.premiseId){
                logger.info("cartCurrent no premiseId")
                return res
            }
            logger.info("cartCurrent premiseId",this.premiseId)
            logger.info("cartCurrent",this.$store.state.cartCurrent)
            logger.info("cartCurrent premise",this.$store.state.cartCurrent[this.premiseId])
            if(this.$store.state && this.$store.state.cartCurrent
                && this.$store.state.cartCurrent[this.premiseId]
                && this.$store.state.cartCurrent[this.premiseId].cart
            ){
                res = this.$store.state.cartCurrent[this.premiseId].cart
            }
            return res
        },
        premiseId(){
            if(this.$store.state.placeIdParam){
                return this.$store.state.placeIdParam
            }else{
                return false
            }
        },
        dayStrings(){
            const res = {}
            const availableMethods = this.$store.state.menu.defalutSettings.serviceProvided
            if(availableMethods.indexOf("adt") < 0){
                return false
            }
            for(let i = 0;i<4;i++){
                let text = ""
                if(this.businessHours["adt"].days[i].calendarText){
                    text += this.businessHours["adt"].days[i].calendarText
                    text += " "
                    text += this.businessHours["adt"].days[i].dayTextLang
                    res[i] = text
                }
            }
            return res
        },
        pickupDays(){
            let res = []
            if(this.$store.state.menu.defalutSettings && this.$store.state.menu.defalutSettings.pickupDays){
                for(let i in this.$store.state.menu.defalutSettings.pickupDays){
                    const day = this.$store.state.menu.defalutSettings.pickupDays[i]
                    switch(day){
                        case "today":
                            if(this.dayStrings[0]){
                                res.push({value:0,text:this.dayStrings[0]})
                            }
                            break
                        case "tomorrow":
                            if(this.dayStrings[1]){
                                res.push({value:1,text:this.dayStrings[1]})
                            }
                            break
                        case "dayAfterTomorrow":
                            if(this.dayStrings[2]){
                                res.push({value:2,text:this.dayStrings[2]})
                            }
                            break
                        case "inThreeDays":
                            if(this.dayStrings[3]){
                                res.push({value:3,text:this.dayStrings[3]})
                            }
                            break
                        default:
                            logger.info("pickupDays funny day",day)
                    }
                }
            }else{
                res = [{value:0,text:"本日"},{value:1,text:"明日"},{value:2,text:"明後日"},{value:3,text:"明々後日"}]
            }
            return res
        },
        businessHours(){
            return this.$store.getters.businessHours(moment())
        },
        userSelect:{
            get() {
                return this.$store.state.userSelect
            },
            set(value) {
                logger.info("setUserSelectMT commit",value)
                this.$store.commit('setUserSelectMT', value)
            }

        },
        deliveryProvider: {
            get() {
                return this.$store.state.deliveryProvider
            },
            set(value) {
                this.$store.commit("setDeliveryProviderMT", value)
            }
        },
    },
    watch:{
        deliveryDuration:function(val){
            this.setDeliveryArrivalTimes(val)
        },
        pickUpDay:function(dayIndex){
            logger.info("pickUpDay Changed")
            this.setDeliveryDay(dayIndex)
            this.$set(this.userSelect,"deliveryTime",undefined)
        }
    }
}
</script>
<style>
    #DpSetDateTime .v-input__control{
        background-color: white;
    }
</style>